import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import { Button, Typography, Menu, ListItemButton } from "@mui/material";
import { useEffect, useMemo, useRef, useState } from "react";
import OZDataGrid from "../../../components/admin/common/OZDataGrid/OZDataGrid";
import OZGridToolbar from "../../../components/admin/common/OZDataGrid/OZGridToolbar";
import "./customTag.css";
import CustomTagsForm from "./CustomTagsForm";
import DeleteDialog from "../../../components/admin/common/CustomDeleteDialog";
import { showErrorNotification, showSuccessNotification } from "../../../components/admin/common/NotiService";
import { NewAdminPages, newAuthPages, newAuthSubAdminAccess, writeAccess } from "../../../services/page-service";
import LoadingScreen from "../../../components/admin/common/OZLoadingScreen/OZLoadingScreen";
import { getCustomTags, deleteCustomTagById, getCustomTagsById, updateCustomTagById, createCustomTag } from "../../../services/api-service";
import { getUserId } from "../../../services/auth-service";

function CustomTags() {
    const [openCustomTagForm, setOpenCustomTagForm] = useState({ isNew: false, show: false });
    const [customTagTableData, setCustomTagTableData] = useState([]);
    const [customTagGridData, setCustomTagGridData] = useState(null);
    const [customTagOnclickRowData, setCustomTagOnclickRowData] = useState(null);
    const [loading, setLoading] = useState(false);

    function EditTagRowOnMouseEnter(props) {
        const [customTagAnchorE1, setCustomTagAnchorE1] = useState(false);
        const anchorRef = useRef();
        const [openCustomTagDeleteDialog, setOpenCustomTagDeleteDialog] = useState(false);
        const [openEditDialog, setOpenEditDialog] = useState(false);
        const [customTagRowData, setCustomTagRowData] = useState({});

        const onClickMoreVertIcon = () => {
            setTimeout(() => setCustomTagAnchorE1(anchorRef?.current), 1);
        };

        const closeCustomTagMorevertMenu = () => {
            setCustomTagAnchorE1(false);
        };

        function onClickDelete() {
            setCustomTagAnchorE1(false);
            setOpenCustomTagDeleteDialog(true);
        }

        const styleListItemButton = useMemo(
            () => ({
                "&.MuiButtonBase-root": {
                    color: '#212121',
                    fontFamily: "Roboto",
                    fontSize: "0.75rem",
                    fontWeight: 400,
                    height: '18px',
                    lineHeight: "14px",
                },
                '&:hover': {
                    borderRadius: "4px",
                },
            }),
            []
        );

        async function deleteTagById() {
            setLoading(true);
            try {
                const resp = await deleteCustomTagById(props.data.customTagId);
                if (resp.Status === 'Fail') {
                    throw new Error(resp.Data);
                }
                if (resp.Status === "Success") {
                    getCustomTagsList();
                    showSuccessNotification(resp.Message);
                }
            } catch (e) {
                showErrorNotification(e.message || "Error in Deleting Custom Tag");
            } finally {
                setLoading(false);
            }
            setOpenCustomTagDeleteDialog(false);
        }

        async function onClickEdit() {
            onCLickRow(props);
            setCustomTagAnchorE1(false);
        }

        return (
            <div className="oz-custom-tag-morevert-column-cell">
                <Typography sx={{ fontSize: "0.75rem", fontWeight: 400, color: "#000000" }}>{props.value ? "Active" : "Inactive"}</Typography>
                {writeAccess() && (newAuthPages(NewAdminPages.CUSTOM_TAGS) || newAuthSubAdminAccess(NewAdminPages.CUSTOM_TAGS, 'Full') || newAuthSubAdminAccess(NewAdminPages.CUSTOM_TAGS, 'Edit')) &&
                    <img className="delMoreIcon"
                        onClick={onClickMoreVertIcon}
                        src={`${process.env.PUBLIC_URL}/icons/more_vert.svg`} alt="edit"
                    >
                    </img>}
                <div ref={anchorRef}>
                    <Menu anchorEl={customTagAnchorE1} open={Boolean(customTagAnchorE1)} onClose={closeCustomTagMorevertMenu} sx={{
                        "& .MuiPaper-root": {
                            backgroundColor: "#FFFFFF",
                            width: "133px",
                            height: "62px",
                        },
                        "& .MuiMenu-paper": {
                            backgroundColor: "#FFFFFF",
                            boxShadow: "0rem 0.25rem 0.75rem rgba(0, 0, 0, 0.04)",
                            border: "0.0625rem solid #E6E5E6",
                            borderRadius: "12px",
                            marginLeft: "-1.0625rem",
                            marginTop: "1.2rem",
                        },
                    }}>
                        <ListItemButton
                            sx={styleListItemButton}
                            onClick={() => { onClickEdit() }}>
                            Edit
                        </ListItemButton>
                        <ListItemButton
                            onClick={onClickDelete}
                            disabled={!props.value || (!(newAuthPages(NewAdminPages.CUSTOM_TAGS) || newAuthSubAdminAccess(NewAdminPages.CUSTOM_TAGS, 'Full')))}
                            sx={{ ...styleListItemButton, marginTop: '7px' }}>
                            Delete
                        </ListItemButton>
                    </Menu>
                    {openCustomTagDeleteDialog && <DeleteDialog
                        open={openCustomTagDeleteDialog}
                        onClose={() => { setOpenCustomTagDeleteDialog(false) }}
                        title="Delete Custom Tag"
                        content={`This will delete Custom Tag: ${props.data.tagName} permanently. You cannot undo this action.`}
                        deleteFunction={deleteTagById} />}
                </div>
                {openEditDialog && <CustomTagsForm updateTags={getCustomTagsList} onClose={() => { setOpenEditDialog(false) }} data={customTagRowData} editAccess={(newAuthPages(NewAdminPages.CUSTOM_TAGS) || newAuthSubAdminAccess(NewAdminPages.CUSTOM_TAGS, 'Full') || newAuthSubAdminAccess(NewAdminPages.CUSTOM_TAGS, 'Edit'))} />}
            </div>
        );
    };

    function TagValueCellRenderer(params) {
        const gridItemStyle = useMemo(
            () => ({
                fontWeight: 400,
                fontSize: "12px",
                color: "#000000"
            }),
            []
        );

        try {
            const tagValueObj = JSON.parse(params.value);
            if (tagValueObj && tagValueObj.length > 0) {
                const allValues = tagValueObj.map(item => {
                    const key = Object.keys(item)[0];
                    return item[key];
                }).flat(); // Use flat() to handle nested arrays

                let displayContent;
                if (allValues.length > 2) {
                    const firstTwoValues = allValues.slice(0, 2).join(', ');
                    const remainingCount = allValues.length - 2;
                    const remainingValues = allValues.slice(2).join(', ');
                    displayContent = (
                        <>
                            <div>
                                {firstTwoValues}
                                <span key="badge" className="badge" title={remainingValues}>
                                    {`+${remainingCount}`}
                                </span>
                            </div>
                        </>
                    );
                } else {
                    displayContent = allValues.join(', ');
                }

                return <Typography style={{ ...gridItemStyle }}>{displayContent}</Typography>;
            }
            return "";
        } catch (e) {
            return params.value;
        }
    }

    async function getCustomTagsList() {
        setLoading(true);
        try {
            const resp = await getCustomTags();
            if (resp.Status === 'Fail') {
                throw new Error(resp.Message);
            }
            if (resp.Status === "Success" && resp.Data && Array.isArray(resp.Data)) {
                setCustomTagTableData(resp.Data)
            }
        } catch (e) {
            console.log("Error in Custom Tags list", e);
            setCustomTagTableData([]);
        } finally {
            setLoading(false);
        }
    }

    async function updateCustomTag(formData, closeCustomTagForm) {
        setLoading(true);
        try {
            const resp = await updateCustomTagById(formData.customTagId, { ...formData, userId: getUserId() });
            if (resp.Status === 'Fail') {
                throw new Error(resp.Message);
            }
            if (resp.Status === "Success") {
                getCustomTagsList();
                showSuccessNotification(`Custom Tag: ${formData.tagName} Updated Successfully`);
                closeCustomTagForm();
            }
        } catch (e) {
            showErrorNotification(e.message || "Error in Updating Custom Tag");
        } finally {
            setLoading(false);
        }
    }

    async function addCustomTag(formData, closeCustomTagForm) {
        setLoading(true)
        try {
            const resp = await createCustomTag({ ...formData, userId: getUserId() });
            if (resp.Status === 'Fail') {
                throw new Error(resp.Message);
            }
            if (resp.Status === "Success") {
                getCustomTagsList();
                showSuccessNotification(`Custom Tag: ${formData.tagName} Created Successfully`);
                closeCustomTagForm();
            }
        } catch (e) {
            showErrorNotification(e.message || "Error in Creating Custom Tag");
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getCustomTagsList();
    }, []);

    const columnDefs = [
        {
            field: "tagName",
            headerName: "Tag Name",
        },
        {
            field: "tagValue",
            headerName: "Tag Value",
            cellRenderer: TagValueCellRenderer,
        },
        {
            field: "isActive",
            headerName: "Status",
            cellRenderer: EditTagRowOnMouseEnter,
        },
    ];

    let buttonStyle = useMemo(
        () => ({
            width: "9.3125rem",
            height: "1.875rem",
            backgroundColor: "#3D8BF8",
            borderRadius: "0.5rem",
            fontSize: "0.875rem",
            fontWeight: 400,
        }),
        []
    );

    const showCustomTagForm = () => {
        setOpenCustomTagForm({ isNew: true, show: true });
    };

    const closeCustomTagForm = () => {
        setOpenCustomTagForm(false);
        setOpenCustomTagForm({ isNew: false, show: false });
    };

    async function onCLickRow(rowItem) {
        setOpenCustomTagForm({ isNew: false, show: true });
        setCustomTagOnclickRowData({});
        try {
            const resp = await getCustomTagsById(rowItem.data.customTagId);
            if (resp.Status === 'Fail') {
                throw new Error(resp.Message);
            }
            if (resp.Status === "Success" && resp.Data) {
                try {
                    if (resp.Data && typeof resp.Data === "object" && "tagValue" in resp.Data && resp.Data.tagValue && typeof resp.Data.tagValue === "string" && resp.Data.tagValue.length > 0) {
                        resp.Data.tagValue = JSON.parse(resp.Data.tagValue)[0][resp.Data.tagName] || [];
                    } else {
                        resp.Data.tagValue = [];
                    }
                } catch (e) {
                    console.log("Error in custom tag list", e);
                    resp.Data.tagValue = [];
                }
                console.log("resp.Data", resp.Data);
                setCustomTagOnclickRowData({
                    tagName: resp?.Data?.tagName || "",
                    tagValue: resp?.Data?.tagValue || [],
                    isActive: resp?.Data?.isActive || false,
                    customTagId: resp?.Data?.customTagId || null
                });
            }
        } catch (e) {
            showErrorNotification("Error in custom tag list");
        }
    }

    return (
        <div className="ozAdminCustomTagContainer oz-custom-tag-main-container" >
            <Typography
                sx={{ fontSize: "0.75rem", lineHeight: "0.875rem", marginBottom: "0.625rem", color: "#212121", }} alignSelf="center">
                Configurations
            </Typography>

            <div className="oz-custom-tag-inner-container">
                <Typography
                    sx={{ fontStyle: "normal", fontWeight: 600, fontSize: "1.5rem", lineHeight: "1.75rem" }} flexGrow={1}>
                    Custom Tags
                </Typography>
                {writeAccess() && (newAuthPages(NewAdminPages.CUSTOM_TAGS) || newAuthSubAdminAccess(NewAdminPages.CUSTOM_TAGS, 'Full')) && <Button
                    sx={{ ...buttonStyle }}
                    variant="contained"
                    startIcon={<AddBoxOutlinedIcon />}
                    onClick={showCustomTagForm}>
                    New Tag
                </Button>}
            </div>

            {openCustomTagForm.show && openCustomTagForm.isNew && (
                <CustomTagsForm
                    updateTags={getCustomTagsList}
                    onClose={closeCustomTagForm}
                    updateCustomTag={updateCustomTag}
                    addCustomTag={addCustomTag}
                />
            )}
            {openCustomTagForm.show && !openCustomTagForm.isNew && (
                <CustomTagsForm
                    updateTags={getCustomTagsList}
                    onClose={closeCustomTagForm}
                    data={customTagOnclickRowData}
                    openDialog={true}
                    editAccess={writeAccess() && (newAuthPages(NewAdminPages.CUSTOM_TAGS) || newAuthSubAdminAccess(NewAdminPages.CUSTOM_TAGS, 'Full') || newAuthSubAdminAccess(NewAdminPages.CUSTOM_TAGS, 'Edit'))}
                    updateCustomTag={updateCustomTag}
                    addCustomTag={addCustomTag}
                />
            )}
            <OZGridToolbar
                showImport={false}
                refreshGrid={getCustomTagsList}
                title='List of Custom Tags'
                searchPlaceholder='Tag Name'
                rowCount={customTagTableData.length}
                dataGridRef={customTagGridData}
                fileName='customTags'
            />
            {loading ?
                (
                    <div style={{ position: 'fixed', top: '0', left: '0', width: '100%', height: '100%', backgroundColor: '0,0,0,0.5', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }} >
                        <LoadingScreen />
                    </div>
                ) :
                (<>
                    <OZDataGrid
                        height={"26.3rem"}
                        columns={columnDefs}
                        data={customTagTableData}
                        setGridRef={setCustomTagGridData}
                        rowClickCallback={onCLickRow}
                    />
                </>
                )
            }
        </div>
    );
}

export default CustomTags; 